import {windowWidth} from '../common';

const $DOC = $(document);

export const studioScripts = () => {

    if ($('#studio_common').length > 0) {

        $DOC
            .on('click', '.openTour', _onOpenTour)
            .on('click', '.show_more_prepods', _onShowMore)
            .on('click', '.closeFrame', _closeFrame)
            .on('keyup', (e) => {if (e.keyCode === 27) _closeFrame() })

        if  (windowWidth > 768) {
            // Owl for studio_page
            $(".owl-carousel").owlCarousel({
                loop:true,
                nav:false,
                items: 1,
                autoplay: true,
                startPosition: 0,
                dots: true,
                autoplayTimeout: 7000,
                smartSpeed: 2000,
                onTranslated : () => {
                    $('.bottom_paggination hr')
                        .width('0%')
                        .animate({width: '100%'}, 5000);
                }
            });
        }
    }
};

// IFrame show 3DTour-script
const _onOpenTour = () =>{
    $('#studio_common section, footer, header').fadeOut(500);
    $('#video_tour').fadeIn(500).removeClass('hide');
    let tourSrc = $('#tourSrc').text();
    $('#video_tour iframe').attr('src', tourSrc);
    $('.closeFrame').on('click',function () {

    });
};

const _closeFrame = () => {
    $('#studio_common section, footer, header').fadeIn(500);
    $('#video_tour').fadeOut(500).removeClass('hide');
    $('#video_tour iframe').attr('src', '');
};

// Show more propods
const _onShowMore = (e) => {
    e.preventDefault();
    let self = e.currentTarget;
    self.parentNode.removeChild(self);
    $('.one_prepod').removeClass('hide');
};